import React, { Component } from 'react';
import PropTypes from 'prop-types';

class LayersTabs extends Component {
  static propTypes = {
    themes: PropTypes.arrayOf(PropTypes.string).isRequired,
    selectLayersTab: PropTypes.func.isRequired,
    selectedTab: PropTypes.string.isRequired,
    getRef: PropTypes.func.isRequired,
  };

  componentDidMount() {
    // pass a reference to this component to its parent
    this.props.getRef(this.layersTab, 'layersTab');
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.selectedTab !== this.props.selectedTab) {
      return true;
    }

    return false;
  }

  renderTabs() {
    const { selectedTab, selectLayersTab } = this.props;

    // note: a prop called "themes" declares this same info, but we need it in this arbitray order
    return ['forests', 'species', 'carbon', 'landscapes'].map(theme => {
      const btnClassName = selectedTab === theme ? 'layers-tab active' : 'layers-tab';
      return (
        <li key={theme}>
          <button className={btnClassName} onClick={() => selectLayersTab(theme)}>
            <div className={`theme-icon-img ${theme}`} />
            <p>{theme}</p>
          </button>
        </li>
      );
    });
  }

  render() {
    return (
      <div
        className="LayersTabs"
        ref={_ => {
          this.layersTab = _;
        }}
      >
        <ul>{this.renderTabs()}</ul>
      </div>
    );
  }
}

export default LayersTabs;



// WEBPACK FOOTER //
// ./src/components/LayersTabs.jsx